import { useState } from "react";

const CHAT_ORIGIN = window.location.origin;

const ChatbotWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <iframe
        src={`${CHAT_ORIGIN}/chat?embed=true`}
        title="Westgate Mall Assistant"
        className={isOpen ? "wg-open" : undefined}
        style={{
          position: "fixed",
          right: "20px",
          bottom: "90px",
          width: "400px",
          height: "min(680px, calc(100vh - 120px))",
          maxWidth: "calc(100vw - 24px)",
          border: "none",
          borderRadius: "18px",
          overflow: "hidden",
          boxShadow: "0 18px 50px rgba(86,29,26,0.28)",
          zIndex: 9998,
          background: "#ffffff",
          opacity: isOpen ? 1 : 0,
          visibility: isOpen ? "visible" : "hidden",
          pointerEvents: isOpen ? "auto" : "none",
          transform: isOpen ? "translateY(0) scale(1)" : "translateY(12px) scale(0.98)",
          transition: "opacity .2s ease, transform .2s ease, visibility .2s ease",
        }}
        data-testid="chatbot-widget-window"
      />
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? "Close Westgate Mall Assistant" : "Open Westgate Mall Assistant"}
        aria-expanded={isOpen}
        style={{
          position: "fixed",
          right: "20px",
          bottom: "20px",
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          background: "linear-gradient(135deg, #EC1A23, #561D1A)",
          color: "white",
          border: "none",
          cursor: "pointer",
          boxShadow: "0 8px 24px rgba(86,29,26,0.35)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
          padding: 0,
        }}
        data-testid="chatbot-widget-btn"
      >
        {isOpen ? (
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        ) : (
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
        )}
      </button>
    </>
  );
};

export const generateEmbedCodes = (baseUrl) => {
  const origin = String(baseUrl).replace(/\/$/, "");
  const iframeCode = `<!-- Westgate Mall Assistant: floating button (bottom-right) -->
<script src="${origin}/widget.js" async></script>`;

  const reactCode = `import { useEffect } from "react";

/** Loads the official Westgate floating chat widget on any React site. */
export default function WestgateChatWidget() {
  useEffect(() => {
    if (document.querySelector('script[src*="widget.js"]')) {
      return undefined;
    }
    const script = document.createElement("script");
    script.src = "${origin}/widget.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      script.remove();
      document.getElementById("westgate-chat-root")?.remove();
      window.__westgateChatWidgetLoaded = false;
    };
  }, []);
  return null;
}`;

  const directLinkCode = `<!-- Always-open embed (no floating button) -->
<iframe
  src="${origin}/chat?embed=true"
  title="Westgate Mall Assistant"
  style="position:fixed;right:20px;bottom:20px;width:400px;height:680px;max-width:calc(100vw - 24px);border:none;border-radius:18px;box-shadow:0 18px 50px rgba(86,29,26,0.28);z-index:9998;"
></iframe>`;

  return { iframeCode, reactCode, directLinkCode };
};

export default ChatbotWidget;
